@if(data()){
  <p class="py-2" [innerHTML]="sanitize(data().data.text)"></p>
}
